import type { Placement } from "@floating-ui/react";

import { FloatingAlignment, FloatingPosition } from "./types";

export const getFloatingPlacement = (
  position: FloatingPosition,
  alignment?: FloatingAlignment
): Placement => {
  if (alignment === "middle" || !alignment) {
    return position;
  }

  return `${position}-${alignment}`;
};
